// Function to fix encoding issues with special characters
export const fixEncoding = text => {
  if (!text || typeof text !== 'string') return text;
  return unescape(
    encodeURIComponent(
      text
        .replace('á', 'a')
        .replace('é', 'e')
        .replace('í', 'i')
        .replace('ó', 'o')
        .replace('ú', 'u')
        .replace('ñ', 'n')
        .replace('à', 'a')
        .replace('è', 'e')
        .replace('ì', 'i')
        .replace('ò', 'o')
        .replace('ù', 'u')
    )
  );
};
